module.exports = __webpack_public_path__ + "static/media/zerak.8b041e00.jpg";